<template>
	<component :is="wrapTag" class="omapi-toggle">
		<!-- For toggles, 'checked' is 'off' -->
		<input
			type="checkbox"
			:checked="checked"
			:disabled="disabled"
			@input="toggle"
			v-bind="$attrs"
		>
		<slot>
			<span class="omapi-toggle__button" @click.prevent="handleOn">
				<slot name="onText">{{ onText }}</slot>
			</span>
			<span class="omapi-toggle__button" @click.prevent="handleOff">
				<slot name="offText">{{ offText }}</slot>
			</span>
		</slot>
	</component>
</template>

<script>
export default {
	inheritAttrs : false,
	props        : {
		/**
		 * Whether value or not.
		 */
		value    : Boolean,
		/**
		 * Whether disabled or not.
		 */
		disabled : Boolean,
		/**
		 * The text for the "on" switch
		 */
		onText   : {
			type    : String,
			default : 'On',
		},
		/**
		 * The text for the "off" switch
		 */
		offText : {
			type    : String,
			default : 'Off',
		},
		/**
		 * The html tag to use.
		 */
		wrapTag : {
			type    : String,
			default : 'label',
		},
	},
	computed : {
		checked () {
			// For toggles, 'checked' is 'off'
			return !this.value
		},
	},
	methods : {
		toggle ($event) {
			// For toggles, 'checked' is 'off'
			this.$emit('input', !event.target.checked)
		},
		handleOn (event) {
			if (this.disabled) {
				return event.preventDefault()
			}
			event.stopPropagation()
			this.$emit('input', true)
		},
		handleOff (event) {
			if (this.disabled) {
				return event.preventDefault()
			}
			event.stopPropagation()
			this.$emit('input', false)
		},
	},
}
</script>
